import { Component } from '@angular/core';

@Component({
  selector: 'skeleton-reto-equipo-ranking',
  templateUrl: 'skeleton-reto-equipo-ranking.html'
})
export class SkeletonRetoEquipoRankingComponent {

}



// WEBPACK FOOTER //
// ./src/components/skeleton-reto-equipo-ranking/skeleton-reto-equipo-ranking.ts